export const environment = {
    production: true,
    apiUrl: `${window.location.protocol}//${window.location.host}/api`,
    web: `${window.location.protocol}//${window.location.host}`,
 /*    hotjar: {
        id: '2700906'
    }, */
/*     pixel: {
        id: '836972093898412'
    }, */
    integrations: {
        gtag: {
            id: 'GTM-KS4RGDN'
        },
        ga: 'UA-197836766-1',
        pixel: '836972093898412',
        hotjar: '2700906'
    },

    site: {

    }
};
